module.exports = __webpack_public_path__ + "static/media/covered_motorcycle.9370de65.png";